import { render } from "./Download.vue?vue&type=template&id=3da61596"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3da61596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3da61596', __exports__)) {
    api.reload('3da61596', __exports__)
  }
  
  module.hot.accept("./Download.vue?vue&type=template&id=3da61596", () => {
    api.rerender('3da61596', render)
  })

}


export default __exports__